import React from 'react';
import styled from 'styled-components';
import Section from '../../common/Section';
import Anchor from '../utils/Anchor';

const Wrapper = styled(Section)`
  padding: 0 var(--default-horizontal-padding);
`;

const WIDGET_SRC =
  'https://join.com/api/widget/bundle/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXR0aW5ncyI6eyJzaG93Q2F0ZWdvcnlGaWx0ZXIiOnRydWUsInNob3dMb2NhdGlvbkZpbHRlciI6dHJ1ZSwic2hvd0VtcGxveW1lbnRUeXBlRmlsdGVyIjp0cnVlLCJsYW5ndWFnZSI6ImVuIiwiam9ic1BlclBhZ2UiOjI1fSwiam9icyI6e30sImRlc2lnbiI6eyJzaG93TG9nbyI6dHJ1ZSwic2hvd0xvY2F0aW9uIjp0cnVlLCJzaG93RW1wbG95bWVudFR5cGUiOnRydWUsInNob3dDYXRlZ29yeSI6dHJ1ZSwiY29sb3JzIjp7IndpZGdldCI6eyJiYWNrZ3JvdW5kIjoiI0ZGRkZGRiIsImZpbHRlckJvcmRlciI6IiNENEQ0RDgiLCJwYWdpbmF0aW9uIjoiIzI1NjNFQiJ9LCJqb2JDYXJkIjp7InNoYWRvdyI6IiNENEQ0RDgiLCJiYWNrZ3JvdW5kIjoiI0ZGRkZGRiIsInByaW1hcnlUZXh0IjoiIzNGM0Y0NiIsInNlY29uZGFyeVRleHQiOiIjNTI1MjVCIn19fSwidmVyc2lvbiI6MiwiY29tcGFueVB1YmxpY0lkIjoiYzA5MzI4ZGQ2ODc2ZDhmNjIyMzQwMTdjYmQ5ZjFiMDUiLCJpYXQiOjE3ODQ1NDA4OTEsImp0aSI6ImJkNTIyMWM2LTg1YmYtNDk3OS1hZTY2LTUyMjg0NmFkYjI1NyJ9.Y64NFR_L-GzyfT7hTyEipqlvc0lVEypltEgYYF3zs8A';

class JoinWidget extends React.Component {
  componentDidMount() {
    const container = document.querySelector('#join-widget');
    const script = document.createElement('script');
    script.defer = true;
    script.type = 'text/javascript';
    script.setAttribute('data-mount-in', '#join-widget');
    script.src = WIDGET_SRC;
    container.appendChild(script);
  }

  render() {
    return (
      <React.Fragment>
        <Anchor id="personio" />
        <Wrapper>
          <div id="join-widget" />
        </Wrapper>
      </React.Fragment>
    );
  }
}

export default JoinWidget;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/careers/JoinWidget.js